import styled from 'styled-components';

const ProjectInfoStyle = styled.div`
	--smallDistance: var(--sp7x);
	--nameWidth: 57.7%;

	--leftPartWidth: 40.4%;
	--rightPartWidth: calc(100% - var(--leftPartWidth));
	--leftTitleWrapWidth: 21%;
	--leftColDistance: var(--sp3x);
	--awardsMT: var(--sp9x);
	--awardsWrapMT: var(--sp5x);
	--imageDistance: var(--sp7x);
	--awardImageHeight: var(--sp9x);

	--rightIntPartWidth: 93.3%;
	--rightColDistance: var(--sp6x);
	--rightColMT: var(--sp9x);
	--rightTitleWrapWidth: 10%;
	--rightDescWrapWidth: calc(100% - var(--rightTitleWrapWidth));

	--solutionDistance: var(--sp6x);

	margin-top: var(--smallDistance);

	.nameServiceWrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--gray44);
		padding-bottom: var(--smallDistance);

		.name {
			width: var(--nameWidth);
		}

		.serviceWrap {
			margin-left: var(--sp2x);
		}
	}

	.informationWrap {
		margin-top: var(--bannerDistance);
		display: flex;
		flex-wrap: wrap;

		.leftPart {
			width: var(--leftPartWidth);

			.leftColWrap {
				.leftCol {
					display: flex;
					align-items: center;

					.leftTitleWrap {
						width: 100%;
						max-width: var(--leftTitleWrapWidth);
						padding-right: var(--sp2x);
					}

					&:not(:first-child) {
						margin-top: var(--leftColDistance);
					}

					.websiteLink {
						display: inline-block;
						border-bottom: 1px solid var(--blackRussian);
					}
				}
			}

			.awards {
				margin-top: var(--awardsMT);
			}

			.awardsWrap {
				display: flex;
				flex-wrap: wrap;
				margin-left: calc(-1 * calc(var(--imageDistance) / 2));
				margin-right: calc(-1 * calc(var(--imageDistance) / 2));
				margin-top: var(--awardsWrapMT);

				.awardImageWrap {
					padding: 0 calc(var(--imageDistance) / 2);
					margin-bottom: var(--imageDistance);

					a {
						display: inline-block;
					}

					.imageCont {
						--proportion: 0;
						height: var(--awardImageHeight);
						display: block;

						span {
							position: relative !important;
							height: 100% !important;
						}

						img {
							position: relative !important;
							width: auto !important;
							height: 100%;
						}
					}
				}
			}
		}

		.rightPart {
			width: var(--rightPartWidth);
			display: flex;
			justify-content: flex-end;

			.rightIntPart {
				width: var(--rightIntPartWidth);

				.rightCol {
					display: flex;

					.rightTitleWrap {
						width: var(--rightTitleWrapWidth);
						display: flex;
						justify-content: flex-end;
						padding-inline-end: calc(var(--rightColDistance) / 2);
					}

					.rightDescWrap {
						width: var(--rightDescWrapWidth);
						padding-inline-start: calc(var(--rightColDistance) / 2);

						.lessMoreAnimWrap {
							margin-top: var(--solutionDistance);

							.lessMoreAnimIntWrap {
								height: 0;
								opacity: 0;
							}

							.btnWrap {
								display: flex;
								justify-content: flex-end;
								margin-top: var(--contentToSmallButtonDistance);
							}
						}

						.additionalStyle {
							white-space: pre-line;
						}
					}

					&:not(:first-child) {
						margin-top: var(--rightColMT);
					}
				}
			}
		}
	}

	//! Line styles and animations
	.btnLineAnim {
		position: relative;

		&:before {
			display: block;
			content: '';
			position: absolute;
			top: 80%;
			height: 2px;
			width: 100%;
			right: 0;
			background-color: var(--blackRussian);
		}

		&:after {
			display: block;
			content: '';
			position: absolute;
			top: 80%;
			left: 0;
			height: 2px;
			background-color: var(--blackRussian);
		}

		&:after,
		&:before {
			padding-bottom: 1px;
		}

		&:hover {
			&:before {
				width: 0%;
				animation: lineAnim var(--trTimeS) ease-out reverse;
			}

			&:after {
				animation: lineAnim var(--trTimeS) var(--trTimeN) ease-out forwards;
			}
		}

		@keyframes lineAnim {
			0% {
				width: 0%;
			}

			100% {
				width: 100%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--smallDistance: var(--sp7x);
		--nameWidth: 57.4%;

		--leftPartWidth: 41.2%;
		--leftTitleWrapWidth: 21%;
		--leftColDistance: var(--sp3x);
		--awardsMT: var(--sp9x);
		--awardsWrapMT: var(--sp5x);
		--imageDistance: var(--sp6x);
		--awardImageHeight: var(--sp7x);

		--rightTitleWrapWidth: 12%;
		--rightIntPartWidth: 96.7%;
		--rightColDistance: var(--sp5x);
		--rightColMT: var(--sp7x);

		--solutionDistance: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--smallDistance: var(--sp5x);
		--nameWidth: 57.5%;

		--leftPartWidth: 40%;
		--leftTitleWrapWidth: 20.5%;
		--leftColDistance: var(--sp3x);
		--awardsMT: var(--sp7x);
		--awardsWrapMT: var(--sp4x);
		--imageDistance: var(--sp5x);
		--awardImageHeight: var(--sp5x);

		--rightTitleWrapWidth: 15%;
		--rightIntPartWidth: 94.3%;
		--rightColDistance: var(--sp4x);
		--rightColMT: var(--sp6x);

		--solutionDistance: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--smallDistance: var(--sp5x);
		--nameWidth: 57.7%;

		--leftPartWidth: 41.7%;
		--leftTitleWrapWidth: 20.7%;
		--leftColDistance: var(--sp3x);
		--awardsMT: var(--sp7x);
		--awardsWrapMT: var(--sp4x);
		--imageDistance: var(--sp5x);
		--awardImageHeight: var(--sp5x);

		--rightTitleWrapWidth: 14.2%;
		--rightIntPartWidth: 100%;
		--rightColDistance: var(--sp4x);
		--rightColMT: var(--sp6x);

		--solutionDistance: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--smallDistance: var(--sp4x);
		--nameWidth: 49%;

		--leftPartWidth: 37.9%;
		--leftTitleWrapWidth: 31.5%;
		--leftColDistance: var(--sp3x);
		--awardsMT: var(--sp5x);
		--awardsWrapMT: var(--sp3x);
		--imageDistance: var(--sp4x);
		--awardImageHeight: var(--sp4x);

		--rightTitleWrapWidth: 19.5%;
		--rightIntPartWidth: 100%;
		--rightColDistance: var(--sp4x);
		--rightColMT: var(--sp6x);

		--solutionDistance: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--smallDistance: var(--sp3x);
		--nameWidth: 48.8%;

		--leftPartWidth: 46.7%;
		--leftTitleWrapWidth: 30.5%;
		--leftColDistance: var(--sp2x);
		--awardsMT: var(--sp7x);
		--awardsWrapMT: var(--sp3x);
		--imageDistance: var(--sp4x);
		--awardImageHeight: var(--sp5x);

		--rightTitleWrapWidth: 27.3%;
		--rightIntPartWidth: 100%;
		--rightColDistance: var(--sp3x);
		--rightColMT: var(--sp5x);

		--solutionDistance: var(--sp4x);

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			//! Disable Line styles and animations
			.btnLineAnim {
				&:hover {
					&:before {
						width: 100%;
						animation: unset;
					}

					&:after {
						animation: unset;
					}
				}

				&:after,
				&:before {
					padding-bottom: 0;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--smallDistance: var(--sp3x);
		--nameWidth: 48.3%;

		--leftPartWidth: 100%;
		--rightPartWidth: 100%;
		--leftTitleWrapWidth: 12.5%;
		--leftColDistance: var(--sp2x);
		--awardsMT: var(--sp6x);
		--awardsWrapMT: var(--sp3x);
		--imageDistance: var(--sp4x);
		--awardImageHeight: var(--sp5x);

		--rightTitleWrapWidth: 22%;
		--rightIntPartWidth: 62%;
		--rightColDistance: var(--sp3x);
		--rightColMT: var(--sp5x);

		--solutionDistance: var(--sp4x);

		.informationWrap {
			.rightPart {
				margin-top: var(--sp1x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			//! Disable Line styles and animations
			.btnLineAnim {
				&:hover {
					&:before {
						width: 100%;
						animation: unset;
					}

					&:after {
						animation: unset;
					}
				}

				&:after,
				&:before {
					padding-bottom: 0;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--smallDistance: var(--sp4x);
		--nameWidth: 100%;

		--leftPartWidth: 100%;
		--rightPartWidth: 100%;
		--leftTitleWrapWidth: 28%;
		--leftColDistance: var(--sp2x);
		--awardsMT: var(--sp4x);
		--awardsWrapMT: var(--sp3x);
		--imageDistance: var(--sp3x);
		--awardImageHeight: var(--sp4x);

		--rightTitleWrapWidth: 25%;
		--rightIntPartWidth: 100%;
		--rightColDistance: var(--sp3x);
		--rightColMT: var(--sp3x);

		--solutionDistance: var(--sp3x);

		.nameServiceWrap {
			flex-direction: column;
			align-items: flex-start;

			.serviceWrap {
				margin-top: var(--sp3x);
				margin-left: 0;
			}
		}

		.informationWrap {
			.rightPart {
				margin-top: var(--sp2x);

				.rightIntPart {
					.rightCol {
						.rightTitleWrap {
							justify-content: flex-start;
						}
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			//! Disable Line styles and animations
			.btnLineAnim {
				&:hover {
					&:before {
						width: 100%;
						animation: unset;
					}

					&:after {
						animation: unset;
					}
				}

				&:after,
				&:before {
					padding-bottom: 0;
				}
			}
		}
	}
`;

export default ProjectInfoStyle;
